import TextQuestionCard from "../QuestionTypes/TextQuestionCard";
import NumberQuestionCard from "../QuestionTypes/NumberQuestionCard";
import PhotoQuestionCard from "../QuestionTypes/PhotoQuestionCard";
import MultipleChoiceQuestion from "../QuestionTypes/MultipleChoiceQuestion";
import SingleChoiceQuestionCard from "../QuestionTypes/SingleChoiceQuestionCard";
import { SURVEY_TYPES } from "./constantsSurveys";

export const COMPONENT_MAP = {
  [SURVEY_TYPES.text]: TextQuestionCard,
  [SURVEY_TYPES.number]: NumberQuestionCard,
  [SURVEY_TYPES.image]: PhotoQuestionCard,
  [SURVEY_TYPES.multipleChoice]: MultipleChoiceQuestion,
  [SURVEY_TYPES.singleChoice]: SingleChoiceQuestionCard
};